import React, { useState, useEffect } from 'react';
import './Stellenausschreibungen.css';
import { host_url } from '../../../App'; // Import host_url
import { Link } from 'react-router-dom';
import { MdFilterList } from "react-icons/md"; // Import the Material Design filter list icon
import BackArrow from '../../../BackArrow'; // Importiere die BackArrow-Komponente

function Stellenausschreibungen() {
  const [jobs, setJobs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [slots, setSlots] = useState({});
  const [showFilters, setShowFilters] = useState(false); // State to toggle filter visibility
  const [filters, setFilters] = useState({
    ganztagesjob: false,
    ueberstunden: false,
    halbtagesjobs: false,
    handwerksjob: false,
  });

  useEffect(() => {
    fetch(`${host_url}/jobs`)
      .then(response => response.json())
      .then(data => setJobs(data))
      .catch(error => console.error('Error fetching job details:', error));
  }, []);

  useEffect(() => {
    fetch(`${host_url}/jobs_verfuegbarkeiten`)
      .then(response => response.json())
      .then(data => {
        const slotsData = {};
        data.forEach(item => {
          if (!slotsData[item.JobID]) {
            slotsData[item.JobID] = {};
          }
          const day = new Date(item.EinheitDatum).getDay();
          const time = item.EinheitStart <= '12:00:00' ? 'morning' : 'afternoon';
          slotsData[item.JobID][`${day}-${time}`] = item.Slots;
        });
        setSlots(slotsData);
      })
      .catch(error => console.error('Error fetching job slots:', error));
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const toggleFilter = (filterName) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterName]: !prevFilters[filterName],
    }));
  };

  const filteredJobs = Array.isArray(jobs)
    ? jobs.filter(job => {
        const matchesSearch = job.Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                              job.Beschreibung.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesFilters = (!filters.ganztagesjob || job.Ganztagesjob) &&
                               (!filters.ueberstunden || job.Ueberstunden) &&
                               (!filters.halbtagesjobs || !job.Ganztagesjob) &&
                               (!filters.handwerksjob || job.Handwerksjob);
        return matchesSearch && matchesFilters;
      })
    : [];

  const sortedJobs = filteredJobs.sort((a, b) => a.Name.localeCompare(b.Name));

  return (
    <div className="stellenausschreibungen-container">
      <div className="page-header">
        <BackArrow to="/jobportal" />
        <h1>Stellenausschreibungen</h1>
      </div>
      <div className="filter-head">
        <div className="search-wrapper">
          <span className="material-symbols-outlined search-icon">search</span>
          <input
            type="text"
            placeholder="Durchsuchen..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <span
          className={`filter-text ${showFilters ? 'selected' : ''}`}
          onClick={() => setShowFilters(!showFilters)}
        >
          <MdFilterList /> Filter
        </span>
      </div>
      {showFilters && (
        <div className="filters">
          <span
            className={`filter-text ${filters.ganztagesjob ? 'selected' : ''}`}
            onClick={() => toggleFilter('ganztagesjob')}
          >
            Ganztagesjob
          </span>
          <span
            className={`filter-text ${filters.halbtagesjobs ? 'selected' : ''}`}
            onClick={() => toggleFilter('halbtagesjobs')}
          >
            Halbtagesjobs
          </span>
          <span
            className={`filter-text ${filters.ueberstunden ? 'selected' : ''}`}
            onClick={() => toggleFilter('ueberstunden')}
          >
            Überstunden
          </span>
          <span
            className={`filter-text ${filters.handwerksjob ? 'selected' : ''}`}
            onClick={() => toggleFilter('handwerksjob')}
          >
            Handwerksjob
          </span>
        </div>
      )}
      {sortedJobs.map((job, index) => (
        <div key={index} className="job-category">
          <div className={`job-title ${activeIndex === index ? 'expanded' : ''}`} onClick={() => toggleAccordion(index)}>
            {job.Name}
            <span className="material-symbols-outlined job-arrow">
              {activeIndex === index ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
            </span>
          </div>
          <div className={`job-details ${activeIndex === index ? 'expanded' : ''}`}>
            <p className="job-description">{job.Beschreibung}</p>
            <p className="job-detail-item">
              <span className="material-symbols-outlined status-icon">
                {job.Ganztagesjob ? 'check' : 'close'}
              </span>
              Ganztagesjob
            </p>
            <p className="job-detail-item">
              <span className="material-symbols-outlined status-icon">
                {job.Ueberstunden ? 'check' : 'close'}
              </span>
              Überstunden
            </p>
            <p className="job-detail-item">
              <span className="material-symbols-outlined status-icon">
                {job.Handwerksjob ? 'check' : 'close'}
              </span>
              Handwerksjob
            </p>
            <table className="job-calendar">
              <thead>
                <tr>
                  <th>Mo</th>
                  <th>Di</th>
                  <th>Mi</th>
                  <th>Do</th>
                  <th>Fr</th>
                </tr>
              </thead>
              <tbody>
                {['morning', 'afternoon'].map(time => (
                  <tr key={time}>
                    {[1, 2, 3, 4, 5].map(day => (
                      <td key={day} className={slots[job.JobID] && slots[job.JobID][`${day}-${time}`] ? 'green' : 'red'}>
                        {slots[job.JobID] && slots[job.JobID][`${day}-${time}`] ? slots[job.JobID][`${day}-${time}`] : '-'}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
            <Link
              to={`/stadtplan?jobId=${job.JobID}`}
              className="location-link"
            >
              <span className="material-symbols-outlined location-icon">map</span>
              <span className="location-label">Stadtplan</span>
            </Link>
          </div>
        </div>
      ))}
      <div className="bottom-spacer"></div>
    </div>
  );
}

export default Stellenausschreibungen;
